import FeaturesDetectorForm from './FeaturesDetectorForm'
import { useGetNewUnitQuery } from '@/modules/add-new-unit/services/newUnitService'
import { UnitSearchReq } from '@/modules/devices-list/types/newUnitsType'
import { useGetUnitsHomeMapMutation } from '@/modules/maps/services/homeMapService'
import { useGetUserProfileQuery } from '@/modules/user/services/userService'
import { UserTypes } from '@/types/typeUser'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import FeaturesLightningForm from '@/modules/device-module/components/features/FeaturesLightningForm'

const FeaturesDetector = () => {
  const { id } = useParams()
  const { data: currentUserData } = useGetUserProfileQuery('0')
  const currentUserType = currentUserData?.data.typeId

  const { data: properties, refetch } = useGetNewUnitQuery(
    { id: Number(id) }
    // {
    //   skip: currentUserType !== UserTypes.superAdmin,
    // }
  )
  const [getDataUnits, { data: units }] = useGetUnitsHomeMapMutation()
  const getLocations = async () => {
    try {
      const usersSearchData: Omit<UnitSearchReq, 'page'> = {
        value: '',
        deviceTypeFilter: [0],
        deviceStateFilter: [0],
        favoriteId: 0,
        lightingTypeId: 0,
      }
      await getDataUnits(usersSearchData).unwrap()
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    getLocations()
  }, [])

  return (
    <>
      {properties?.data && currentUserType && (
        <FeaturesDetectorForm
          refetch={refetch}
          formValues={properties.data as any}
          units={units}
          currentUserType={currentUserType}
        />
      )}
    </>
  )
}

export default FeaturesDetector
